<template>
  <BuyList
      :items="items.filter(item=> item.Factor_Buy_State===1 && item.Buy_State===1 && item.Recipt_Num && item.Recipt_State===1)"
      title="لیست فاکتورهای خرید"
      :read-only = "true"
      :no-price="false"
      :no-order-info="false"
      :compact-view="$q.screen.lt.md"
      :is-dialog="false"
      :is-searching="true"
      :filter="searchKey"/>
</template>

<script>
import {mapActions} from "vuex";
import BuyList from "@/components/Buys/BuyList.vue";

export default {
  name: "TotalBuyFactors",
  components: {BuyList},
  data() {
    return {
      items: [],
      searchKey:undefined
    }
  },
  methods: {
    ...mapActions({
      getOrderTrace: 'Buys/getOrderTraceList'
    })
  },
  created() {
    this.getOrderTrace().then((res) => {
      this.items = res
    })
  }
}
</script>

<style scoped>

</style>